/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PaymentPlanMarketing } from './PaymentPlanMarketing';
import {
    PaymentPlanMarketingFromJSON,
    PaymentPlanMarketingFromJSONTyped,
    PaymentPlanMarketingToJSON,
} from './PaymentPlanMarketing';
import type { PaymentPlanMetadata } from './PaymentPlanMetadata';
import {
    PaymentPlanMetadataFromJSON,
    PaymentPlanMetadataFromJSONTyped,
    PaymentPlanMetadataToJSON,
} from './PaymentPlanMetadata';

/**
 * 
 * @export
 * @interface PaymentPlan
 */
export interface PaymentPlan {
    /**
     * 
     * @type {string}
     * @memberof PaymentPlan
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentPlan
     */
    object?: string;
    /**
     * 
     * @type {PaymentPlanMetadata}
     * @memberof PaymentPlan
     */
    metadata?: PaymentPlanMetadata;
    /**
     * 
     * @type {number}
     * @memberof PaymentPlan
     */
    amount?: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentPlan
     */
    trial_period_days?: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentPlan
     */
    created?: number;
    /**
     * 
     * @type {string}
     * @memberof PaymentPlan
     */
    currency?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentPlan
     */
    interval?: string;
    /**
     * 
     * @type {number}
     * @memberof PaymentPlan
     */
    interval_count?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentPlan
     */
    livemode?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentPlan
     */
    active?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PaymentPlan
     */
    billing_scheme?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentPlan
     */
    product?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentPlan
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentPlan
     */
    usage_type?: string;
    /**
     * 
     * @type {number}
     * @memberof PaymentPlan
     */
    discount?: number;
    /**
     * Minimum commitment in months, merged from the ClinicPaymentPlan record. Absent or 0 disables the commitment period and contract-signing featureset for this plan.
     * @type {number}
     * @memberof PaymentPlan
     */
    minimum_months?: number;
    /**
     * Marks the plan card as highlighted ("most popular") on the subscribe screen. Merged from the ClinicPaymentPlan record.
     * @type {boolean}
     * @memberof PaymentPlan
     */
    highlight?: boolean;
    /**
     * Display bullets for the plan card on the subscribe screen. Merged from the ClinicPaymentPlan record.
     * @type {Array<string>}
     * @memberof PaymentPlan
     */
    features?: Array<string>;
    /**
     * Practitioner skills a patient on this plan is entitled to book. Merged from the ClinicPaymentPlan record. A skill named by any plan is restricted to patients whose plan unlocks it.
     * @type {Array<string>}
     * @memberof PaymentPlan
     */
    unlocks_skills?: Array<string>;
    /**
     * 
     * @type {PaymentPlanMarketing}
     * @memberof PaymentPlan
     */
    marketing?: PaymentPlanMarketing;
}

/**
 * Check if a given object implements the PaymentPlan interface.
 */
export function instanceOfPaymentPlan(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;

    return isInstance;
}

export function PaymentPlanFromJSON(json: any): PaymentPlan {
    return PaymentPlanFromJSONTyped(json, false);
}

export function PaymentPlanFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentPlan {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'object': !exists(json, 'object') ? undefined : json['object'],
        'metadata': !exists(json, 'metadata') ? undefined : PaymentPlanMetadataFromJSON(json['metadata']),
        'amount': !exists(json, 'amount') ? undefined : json['amount'],
        'trial_period_days': !exists(json, 'trial_period_days') ? undefined : json['trial_period_days'],
        'created': !exists(json, 'created') ? undefined : json['created'],
        'currency': !exists(json, 'currency') ? undefined : json['currency'],
        'interval': !exists(json, 'interval') ? undefined : json['interval'],
        'interval_count': !exists(json, 'interval_count') ? undefined : json['interval_count'],
        'livemode': !exists(json, 'livemode') ? undefined : json['livemode'],
        'active': !exists(json, 'active') ? undefined : json['active'],
        'billing_scheme': !exists(json, 'billing_scheme') ? undefined : json['billing_scheme'],
        'product': !exists(json, 'product') ? undefined : json['product'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'usage_type': !exists(json, 'usage_type') ? undefined : json['usage_type'],
        'discount': !exists(json, 'discount') ? undefined : json['discount'],
        'minimum_months': !exists(json, 'minimum_months') ? undefined : json['minimum_months'],
        'highlight': !exists(json, 'highlight') ? undefined : json['highlight'],
        'features': !exists(json, 'features') ? undefined : json['features'],
        'unlocks_skills': !exists(json, 'unlocks_skills') ? undefined : json['unlocks_skills'],
        'marketing': !exists(json, 'marketing') ? undefined : PaymentPlanMarketingFromJSON(json['marketing']),
    };
}

export function PaymentPlanToJSON(value?: PaymentPlan | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'object': value.object,
        'metadata': PaymentPlanMetadataToJSON(value.metadata),
        'amount': value.amount,
        'trial_period_days': value.trial_period_days,
        'created': value.created,
        'currency': value.currency,
        'interval': value.interval,
        'interval_count': value.interval_count,
        'livemode': value.livemode,
        'active': value.active,
        'billing_scheme': value.billing_scheme,
        'product': value.product,
        'name': value.name,
        'usage_type': value.usage_type,
        'discount': value.discount,
        'minimum_months': value.minimum_months,
        'highlight': value.highlight,
        'features': value.features,
        'unlocks_skills': value.unlocks_skills,
        'marketing': PaymentPlanMarketingToJSON(value.marketing),
    };
}

